import { useTranslation } from 'react-i18next';

import { Link, Stack } from '@mui/material';

import Button from '../../../components/Button';
import Header from '../../../components/Header';
import { i18nNS } from '../../../i18n';
import ChevronLeftIcon from '../../../icons/ChevronLeftIcon';
import ChevronRightIcon from '../../../icons/ChevronRightIcon';
import CloseIcon from '../../../icons/CloseIcon';
import { Image, StyledDialog } from './styles';
import usePromotionalTipPanel, { UsePromotionalTipPanel } from './vm';

export interface PromotionalTipPanelProps extends UsePromotionalTipPanel {}

const PromotionalTipPanel = ({ ...vmProps }: PromotionalTipPanelProps) => {
  const { t } = useTranslation([i18nNS.GLOSSARY]);

  const {
    isOpen,
    promotionalTip: { closeButtonText, closeButtonLink },
  } = vmProps;
  const {
    currentStep,
    isLastStep,
    canSeePrevious,
    canVisitPrevious,
    handlePrevious,
    canVisitNext,
    handleNext,
    handleClose,
  } = usePromotionalTipPanel(vmProps);

  return (
    <StyledDialog
      open={isOpen}
      onClose={handleClose}
      disableFullscreen
      maxWidth="sm"
      fullWidth
      header={(titleId) => (
        <Header
          id={titleId}
          right={
            isLastStep
              ? {
                  onClick: handleClose,
                  children: <CloseIcon aria-hidden />,
                }
              : undefined
          }
        >
          {currentStep.title}
        </Header>
      )}
      footer={
        <Stack width="100%" direction="row" justifyContent="space-between" alignItems="center">
          {canSeePrevious ? (
            <Button
              variant="outlined"
              onClick={handlePrevious}
              disabled={!canVisitPrevious}
              startIcon={<ChevronLeftIcon aria-hidden />}
            >
              {t('previous', { ns: i18nNS.GLOSSARY })}
            </Button>
          ) : (
            <div />
          )}
          {!isLastStep ? (
            <Button onClick={handleNext} disabled={!canVisitNext} endIcon={<ChevronRightIcon aria-hidden />}>
              {t('next', { ns: i18nNS.GLOSSARY })}
            </Button>
          ) : closeButtonLink ? (
            <Button component={Link} href={closeButtonLink} target="_blank">
              {closeButtonText}
            </Button>
          ) : (
            <Button onClick={handleClose}>{closeButtonText}</Button>
          )}
        </Stack>
      }
    >
      <Stack gap={4}>
        <Image src={currentStep.image} alt="" />
        <div dangerouslySetInnerHTML={{ __html: currentStep.caption }} />
      </Stack>
    </StyledDialog>
  );
};

export default PromotionalTipPanel;
